import config from "@/config";
import * as _ from "lodash-es";
import http from "@/utils/request";
import safeGet from "@fengqiaogang/safe-get";

export default {
  list: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/list`,
    name: "获取产品列表",
    post: async function (params = {}) {
      const query = {
        pageNum: 1,
        pageSize: 10,
        ...params
      };
      return await http.post(this.url, query);
    }
  },
  getMyBugList: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/myBugList`,
    name: "获取产品列表",
    post: async function (params) {
      return await http.post(this.url, params);
    }
  },
  getBugCenterList: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getProjectBugs`,
    name: "Bug 中心缺陷列表",
    get: async function (params) {
      return await http.get(this.url, params);
    }
  },
  getBugUser: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugUsers?projectNum=`,
    name: "获取BUG相关人员信息",
    get: async function (param1, param2) {
      return await http.get(this.url + param1 + '&target=' + param2);
    }
  },
  addBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo`,
    name: "提交BUG",
    post: async function (data) {
      return await http.post(this.url, data);
    }
  },
  updateBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo`,
    name: "提交BUG",
    put: async function (data) {
      return await http.put(this.url, data);
    }
  },
  deleteBugInfo: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/`,
    name: "修改测试用例与测试关联项",
    delete: async function (bugId) {
      return await http.delete(this.url + bugId);
    }
  },
  dealBugWithLang: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/dealLang`,
    name: "BUG已解决同步语言包",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  submitBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/submitTapdBug`,
    name: "BUG已解决同步语言包(提交按钮)",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  // 更新Bug 详情，流转节点数据
  submitFlowNode: {
    post: function (data) {
      return http.post("/lqa-game/system/bugInfo/bugSubmitTapd", data);
    }
  },
  dealBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/deal`,
    name: "BUG不同步语言包",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  batchUpdate: {
    put: function (data) {
      return http.post("/lqa-game/system/bugInfo/batchUpdate", data);
    }
  },
  batchDealBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/batchDeal`,
    name: "BUG批量处理",
    post: function (data, config = {timeout: 50000}) {
      return http.post(this.url, data, config);
    }
  },
  getBugDealCount: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugDealCount?versionNum=`,
    name: "获取BUG待办和已办总量",
    get: function (params) {
      return http.get(this.url + params);
    }
  },
  bugTurnOutPerson: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/changeBugUser`,
    name: "BUG转出到人",
    post: function (data) {
      return http.post(this.url, data, config);
    }
  },

  getBugPage: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugPage?bugId=`,
    name: "BUG批量处理",
    get: function (param) {
      return http.get(this.url + param);
    }
  },

  turnOutUser: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/turnPerson`,
    name: "转出到人",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  saveBugInfo: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/updateInfo`,
    name: "转出到人",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  turnToPm: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/turnPm`,
    name: "转出到人",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  refuseBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/refuse`,
    name: "转出到人",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  notBug: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/nab`,
    name: "转出到人",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  getAllBugDealPerson: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugPerson?versionNum=`,
    name: "获取所有BUG处理人",
    get: function (param1) {
      return http.get(this.url + param1);
    }
  },
  getAllBugCreatePerson: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugCreatePerson?versionNum=`,
    name: "获取所有BUG处理人",
    get: function (param1) {
      return http.get(this.url + param1);
    }
  },

  getBugFile: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugFile?bugId=`,
    name: "获取BUG附件",
    get: function (param1) {
      return http.get(this.url + param1);
    }
  },
  getBugProcess: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/showBugButton`,
    name: "获取BUG当前流程",
    get: function (bugId) {
      return http.get(this.url, {bugId});
    }
  },
  uploadImageInfo: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/addImageInfo`,
    name: "修改测试用例与测试关联项",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  tapdLang: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getTapdLang`,
    name: "获取BUG当前流程",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  langOption: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugLang`,
    name: "获取BUG当前流程",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  removeFileInfo: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/removeImageInfo?fileId=`,
    name: "删除附件",
    get: function (param1) {
      return http.get(this.url + param1);
    }
  },
  start: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/startProcess`,
    name: "提交BUG流程",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  getBugPerson: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugDealPerson`,
    name: "获取任务相关人员信息",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  bugNextNodes: {
    get: async function (projectId, bugStatus) {
      const params = {
        projectNum: projectId,
        statusCode: bugStatus,
      };
      let res;
      const list = [];
      try {
        res = await http.get("/lqa-game/system/bugInfo/getNowBugNodes", params);
      } catch (e) {
        // todo
      }
      if (res && res.code === 200) {
        const nodes = (safeGet(res, "data.nodes") || "").split(",");
        const users = (safeGet(res, "data.users") || "").split(",");
        for (let i = 0, size = nodes.length; i < size; i++) {
          const code = _.trim(nodes[i]);
          if (code.length > 0) {
            const user = users[i];
            if (user && user === "y") {
              list.push({code, user: false});
            } else {
              list.push({code, user: true});
            }
          }
        }
      }
      return list;
    }
  },
  getBugInfo: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getBugInfo?bugId=`,
    name: "获取BUG相关信息",
    get: function (params) {
      return http.get(this.url + params);
    }
  },
  getRemark: {
    get: async function (bugId) {
      try {
        const res = await http.get("/lqa-game/system/bugInfo/getbugRemark", {bugId});
        if (res && res.code === 200) {
          return res.data;
        }
      } catch (e) {
        console.log(e);
        // todo
      }
      return [];
    }
  },
  getBugLanguage: {
    url: `${config.API_URL}/lqa-game/system/item/`,
    name: "获取语言包详情",
    get: async function (param) {
      return await http.get(this.url + param);
    }
  },
  getTremSearch: {
    url: `${config.API_URL}/lqa-game/system/termdata/termSearch`,
    name: "获取术语库匹配结果",
    post: async function (data) {
      return await http.post(this.url, data);
    }
  },
  exportBugExcel: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/export`,
    name: "BUG导出",
    post: async function (params, config = {timeout: 500000}) {
      return await http.post(this.url, params, config);

    },
  },
  bugInfoUpload: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/upload`,
    name: "附件上传",
    post: async function (data, config = {timeout: 500000}) {
      return await http.post(this.url, data, config);
    }
  },

  listExport: {
    url: `${config.API_URL}/lqa-game/system/bugExport/list`,
    name: "附件上传",
    post: async function (data,) {
      return await http.post(this.url, data);
    }
  },
  delExport: {
    url: `${config.API_URL}/lqa-game/system/bugExport/`,
    name: "附件上传",
    delete: async function (data,) {
      return await http.delete(this.url, data);
    }
  },
}